import React, { Fragment, useEffect, useRef, useState } from "react";
import { CustomGetAPI, CustomPostAPI } from "../Utils/APIConnector";
import { result } from "lodash";
import Swal from "sweetalert2";
import Loader from "../Utils/Loader";

export default function VenueOwnerPlanListing({
  venueID,
  venuePlanDetials,
  getPlanDetails,
  venueOwnerPlans,
}) {
  const [Filter, setFilter] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(0);
  const [loader, setLoader] = useState({ status: false, plan: "" });
  const [pageLoader, setPageLoader] = useState(false);
  const FilterRef = useRef(null);

  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
    );
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  const startSubscription = async (planId) => {
    setLoader({ status: true, plan: planId });
    try {
      const raw = JSON.stringify({ planid: planId, venueid: venueID });
      await CustomPostAPI(`/VenueOwnerPlan/createsubscription`, raw).then(
        (result) => {
          result = JSON.parse(result);
          if (result) {
            let options = {
              image: "https://dev.cricbuddy.in/images/cricketFlash.svg",
              subscription_id: result?.id,
              handler: async (data) => {
                // console.log(data);
                Swal.fire({
                  title: "It will take upto 5min to active this subscription",
                });
              },
              theme: {
                color: "#F3F3F3",
              },
              config: {
                display: {
                  hide: [
                    { method: "paylater" },
                    { method: "netbanking" },
                    { method: "wallet" },
                  ],
                },
              },
              webview_intent: true,
              //timeout: 300,
              modal: {
                ondismiss: function () {
                  document.body.style.overflow = "auto";
                },
              },
            };
            const paymentObject = new window.Razorpay(options);
            paymentObject.on("payment.failed", function (response) {
              console.log("error", response);
            });
            paymentObject.open();
          }
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoader({ status: false, plan: "" });
    }
  };
  const cancelSubscription = async () => {
    Swal.fire({
      title: "Are you sure you want to cancel this subscription?",
      text: "If cancel this plan you will be move to commission based plan.",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setPageLoader(true);
        try {
          const raw = JSON.stringify({ venueid: venueID });
          await CustomPostAPI(`/VenueOwnerPlan/cancelsubscription`, raw).then(
            (result) => {
              result = JSON.parse(result);

              if (result?.status == "Success") {
                Swal.fire({
                  title: "Subscription Cancelled!",
                  text: "You will be moved to commission based plan.",
                });
                getPlanDetails();
              } else {
                Swal.fire({
                  title: result?.message,
                });
              }
            }
          );
        } catch (error) {
          console.log(error);
        } finally {
          setPageLoader(false);
        }
      }
    });
  };
  useEffect(() => {
    function handleClickOutside(ref) {
      return function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setFilter(false);
        }
      };
    }
    const handleFilterClick = handleClickOutside(FilterRef);
    document.addEventListener("mousedown", handleFilterClick);

    return () => {
      document.removeEventListener("mousedown", handleFilterClick);
    };
  }, [FilterRef]);

  return (
    <Fragment>
      {pageLoader ? (
        <Loader />
      ) : (
        <>
          <div className="row mx-0">
            <div
              className="col-12 mb-3 mt-4 py-2"
              style={{ border: "1px solid #A51E22", borderRadius: "8px" }}
              onClick={() => {
                setFilter(true);
                setSelectedFilter(0);
              }}
            >
              <div className="d-flex justify-content-between">
                <div className="clr-A51E22 fw-600 font-18">
                  Basic Plan{" "}
                  {
                    venuePlanDetials?.plan?.name == "Basic Plan" &&
                    venuePlanDetials?.status === 1 ? (
                      <span className="font-14">(Active Plan)</span>
                    ) : (
                      ""
                    )
                    // (venuePlanDetials?.plan?.name == "Basic Plan" && venuePlanDetials?.status === 2) ? <span className="font-14">(Cancelled)</span> : ""
                  }
                </div>
                <div className="clr-A51E22 fw-600 font-14 text-decoration-underline">
                  View Details
                </div>
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> 2 Default Views
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> Dashboard Access
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> 1 Staff Member
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> Special Package Plan
                Offer Included
              </div>
            </div>
            <div
              className="col-12 mt-2 mb-3 py-2"
              style={{ border: "1px solid #A51E22", borderRadius: "8px" }}
              onClick={() => {
                setFilter(true);
                setSelectedFilter(1);
              }}
            >
              <div className="d-flex justify-content-between">
                <div className="clr-A51E22 fw-600 font-18">
                  Pro Plan
                  {
                    venuePlanDetials?.plan?.name == "Pro Plan" &&
                    venuePlanDetials?.status === 1 ? (
                      <span className="font-14">(Active Plan)</span>
                    ) : (
                      ""
                    )
                    // (venuePlanDetials?.plan?.name == "Pro Plan" && venuePlanDetials?.status === 2) ? <span className="font-14">(Cancelled)</span> : ""
                  }
                </div>
                <div className="clr-A51E22 fw-600 font-14 text-decoration-underline">
                  View Details
                </div>
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> All Basic Plan
                features
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> WhatsApp
                Notifications
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> Easy Slot Booking
                View
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> Promoted Listing
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> Unlimited Staff
                Members
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> 1 Instagram Reel
                Collab & Post (1 per quarter)
              </div>
            </div>
            <div
              className="col-12 mt-2 mb-3 py-2"
              style={{ border: "1px solid #A51E22", borderRadius: "8px" }}
              onClick={() => {
                if (
                  venuePlanDetials?.plan?.name !== "Commission Based" &&
                  venuePlanDetials?.plan?.name !== "Free Plan" &&
                  venuePlanDetials?.status === 1
                ) {
                  setFilter(true);
                  setSelectedFilter(2);
                }
              }}
            >
              <div className="d-flex justify-content-between">
                <div className="clr-A51E22 fw-600 font-18">
                  Commission Based{" "}
                  {
                    venuePlanDetials?.plan?.name == "Commission Based" &&
                    venuePlanDetials?.status === 1 ? (
                      <span className="font-14">(Active Plan)</span>
                    ) : (
                      ""
                    )
                    // (venuePlanDetials?.plan?.name == "Pro Plan" && venuePlanDetials?.status === 2) ? <span className="font-14">(Cancelled)</span> : ""
                  }
                </div>
                {venuePlanDetials?.plan?.name !== "Commission Based" &&
                  venuePlanDetials?.plan?.name !== "Free Plan" &&
                  venuePlanDetials?.status === 1 && (
                    <div className="clr-A51E22 fw-600 font-14 text-decoration-underline">
                      View Details
                    </div>
                  )}
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> All Basic Plan
                features
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> WhatsApp
                Notifications
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> Easy Slot Booking
                View
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> Unlimited Staff
                Members
              </div>
              <div className="clr-A51E22 fw-600 font-13">
                Add ON (Chargeable)
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" /> 1 Instagram Reel
                Collab & Post (1 per quarter)
              </div>
              <div className="my-2 clr-484848 fw-500 font-14">
                <img src="/images/planchecks.svg" alt="" />  Promoted Listing
              </div>
            </div>
          </div>
          <div
            className={`fade modal-backdrop ${Filter ? "show" : "d-none"}`}
          ></div>
          <div
            className={`filter-popup bg-F4F4F4 ${
              Filter ? "visible" : "d-none"
            }`}
            ref={FilterRef}
          >
            {" "}
            <div
              className="popup-content"
              style={{ padding: "20px", paddingBottom: "5px" }}
            >
              <div className="text-start ">
                <div className="fw-500">
                  Subscription Details{" "}
                  {/* {selectedFilter == 1 && (
                    <span className="fw-400">(Diwali Offer)</span>
                  )} */}
                </div>
                {selectedFilter == 0 ? (
                  <>
                    {venuePlanDetials?.plan?.name == "Basic Plan" &&
                    venuePlanDetials?.status === 1 ? (
                      <>
                        <div
                          className="d-flex justify-content-between align-items-center bg-white px-2 py-2 my-3"
                          style={{
                            border: "1px solid #0000001A",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="fw-500">Basic Plan</div>

                          <button
                            className="packageDetailsBtn"
                            onClick={() => {
                              cancelSubscription();
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="d-flex justify-content-between align-items-center bg-white px-2 py-2 my-3"
                          style={{
                            border: "1px solid #0000001A",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="fw-500">Basic Plan</div>
                          <div className="clr-A51E22 fw-600">
                            ₹{venueOwnerPlans?.[0]?.amount}/
                            <span className="fw-400">Month</span>
                          </div>
                          <div className="d-flex me-2">
                            <button
                              className="packageDetailsBtn"
                              onClick={() => {
                                startSubscription(venueOwnerPlans?.[0]?.planId);
                              }}
                              disabled={loader?.status}
                            >
                              Upgrade
                            </button>
                            {loader?.status &&
                              loader?.plan === venueOwnerPlans?.[0]?.planId && (
                                <span className="ms-2">
                                  <Loader mt="0px" height="20px" width="20px" />
                                </span>
                              )}
                          </div>
                        </div>
                        <div
                          className="d-flex justify-content-between align-items-center bg-white py-2 px-2 my-3"
                          style={{
                            border: "1px solid #0000001A",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="fw-500">Basic Plan</div>
                          <div className="clr-A51E22 fw-600">
                            ₹{venueOwnerPlans?.[1]?.amount}/
                            <span className="fw-400">Year</span>
                          </div>
                          <div className="d-flex me-2">
                            <button
                              className="packageDetailsBtn"
                              onClick={() => {
                                startSubscription(venueOwnerPlans?.[1]?.planId);
                              }}
                              disabled={loader?.status}
                            >
                              Upgrade
                            </button>
                            {loader?.status &&
                              loader?.plan === venueOwnerPlans?.[1]?.planId && (
                                <span className="ms-2">
                                  <Loader mt="0px" height="20px" width="20px" />
                                </span>
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : selectedFilter == 1 ? (
                  <>
                    {venuePlanDetials?.plan?.name == "Pro Plan" &&
                    venuePlanDetials?.status === 1 ? (
                      <>
                        <div
                          className="d-flex justify-content-between align-items-center bg-white px-2 py-2 my-3"
                          style={{
                            border: "1px solid #0000001A",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="fw-500">Pro Plan</div>
                          <button
                            className="packageDetailsBtn"
                            onClick={() => {
                              cancelSubscription();
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="d-flex justify-content-between align-items-center bg-white px-2 py-2 my-3"
                          style={{
                            border: "1px solid #0000001A",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="fw-500">Pro Plan</div>
                          <div className="clr-A51E22 fw-600">
                            ₹{venueOwnerPlans?.[2]?.amount}/
                            <span className="fw-400">Month</span>
                          </div>
                          <div className="d-flex me-2">
                            <button
                              className="packageDetailsBtn"
                              onClick={() => {
                                startSubscription(venueOwnerPlans?.[2]?.planId);
                              }}
                              disabled={loader?.status}
                            >
                              Upgrade
                            </button>
                            {loader?.status &&
                              loader?.plan === venueOwnerPlans?.[2]?.planId && (
                                <span className="ms-2">
                                  <Loader mt="0px" height="20px" width="20px" />
                                </span>
                              )}
                          </div>
                        </div>
                        <div
                          className="d-flex justify-content-between align-items-center bg-white py-2 px-2 my-3"
                          style={{
                            border: "1px solid #0000001A",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="fw-500">Pro Plan</div>
                          <div className="clr-A51E22 fw-600">
                            ₹{venueOwnerPlans?.[3]?.amount}/
                            <span className="fw-400">Year</span>
                          </div>
                          <div className="d-flex me-2">
                            <button
                              className="packageDetailsBtn"
                              onClick={() => {
                                startSubscription(venueOwnerPlans?.[3]?.planId);
                              }}
                              disabled={loader?.status}
                            >
                              Upgrade
                            </button>
                            {loader?.status &&
                              loader?.plan === venueOwnerPlans?.[3]?.planId && (
                                <span className="ms-2">
                                  <Loader mt="0px" height="20px" width="20px" />
                                </span>
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <div
                      className="d-flex justify-content-between align-items-center bg-white px-2 py-2 my-3"
                      style={{
                        border: "1px solid #0000001A",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="fw-500">
                        {venuePlanDetials?.plan?.name}
                      </div>

                      <button
                        className="packageDetailsBtn"
                        onClick={() => {
                          cancelSubscription();
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
}
